import React from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "formik";
import { Button } from "react-bootstrap";
import Select from "react-select";

const Form = ({
  values,
  handleChange,
  handleBlur,
  handleSubmit,
  setFieldValue,
  toggleSuburbsModal,
  stateListing,
  stateLoading
}) => {
  Form.propTypes = {
    values: PropTypes.object,
    errors: PropTypes.any,
    handleChange: PropTypes.any,
    handleBlur: PropTypes.any,
    setFieldValue: PropTypes.any,
    handleSubmit: PropTypes.any,
    overwrittenFields: PropTypes.array,
    existingValues: PropTypes.array,
    toggleSuburbsModal: PropTypes.any,
    officeListing: PropTypes.any,
    officeLoading: PropTypes.any,
    roleLoading: PropTypes.any,
    roleListing: PropTypes.any,
  };

  return (
    <form onSubmit={handleSubmit} noValidate className="entry-section">
      <div className="form-box">
        <div className="form-group full-width">
          <label>
            <span className="required">*</span>Select State
          </label>
          <Select
            name="state_id"
            value={values?.state_id ? values?.state_id : ""}
            onChange={(e) => {
              setFieldValue(`state_id`, e ? e : "");
              setFieldValue(`suburb_id`, "");
            }}
            onBlur={handleBlur}
            options={stateListing}
            placeholder="Select State"
            classNamePrefix="selectbox"
            isClearable
            isLoading={stateLoading}
            autoComplete="off"
            onKeyPress={(e) => {
              e.which === 13 && e.preventDefault();
            }}
          />

          <span
            className="text-danger"
            style={{ color: "red", fontSize: "20px" }}
          >
            <ErrorMessage name="state_id" />
          </span>
        </div>
        <div className="form-group full-width">
          <label>
            <span className="required">*</span>Name
          </label>
          <input
            type="text"
            name="name"
            value={values?.name ? values?.name : ""}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="off"
            onKeyPress={(e) => {
              e.which === 13 && e.preventDefault();
            }}
          />
          <span
            className="text-danger"
            style={{ color: "red", fontSize: "20px" }}
          >
            <ErrorMessage name="name" />
          </span>
        </div>
      </div>

      <div className="modal-footer">
        <Button type="submit">Save</Button>
        <Button
          className="btn btn-secondary"
          data-dismiss="modal"
          aria-label="Close"
          type="Button"
          onClick={() => {
            toggleSuburbsModal();
          }}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default Form;
